import { render } from "../../views/footer-buttons/transcript_modal.html?vue&type=template&id=002da2b2&ts=true&external"
import script from "../../scripts/footer-buttons/transcript_modal.ts?vue&type=script&lang=ts&external"
export * from "../../scripts/footer-buttons/transcript_modal.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"ClientApp/components/footer-buttons/transcript_modal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "002da2b2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('002da2b2', __exports__)) {
    api.reload('002da2b2', __exports__)
  }
  
  module.hot.accept("../../views/footer-buttons/transcript_modal.html?vue&type=template&id=002da2b2&ts=true&external", () => {
    api.rerender('002da2b2', render)
  })

}


export default __exports__